import React from "react";
import PublicLayout from "@/components/PublicLayout";
import { Link } from "react-router-dom";
import WhatsAppButton from "@/components/WhatsAppButton";
import Seo from "@/components/Seo";
import { waMessages } from "@/lib/whatsapp";
import { ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <PublicLayout>
      <Seo title="Page Not Found" description="Sorry, we couldn't find that page. View available Manchester PHV cars or WhatsApp EazyCarTrack." noindex path="/404" />
      <div className="container-x flex min-h-[60vh] flex-col items-start justify-center py-20">
        <span className="font-heading text-7xl font-black text-[#00E676]">404</span>
        <h1 className="mt-4 font-heading text-3xl font-bold">Sorry, we couldn't find that page.</h1>
        <p className="mt-3 max-w-md text-zinc-600">
          The page you're looking for doesn't exist or may have moved. Try one of these instead.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link to="/cars" className="inline-flex h-12 items-center justify-center gap-2 rounded-full bg-ink px-6 font-bold text-white">View Available Cars <ArrowRight className="h-4 w-4" /></Link>
          <Link to="/taxi-rental-manchester" className="inline-flex h-12 items-center justify-center rounded-full border border-border px-6 font-bold hover:bg-surface">Taxi Rental Manchester</Link>
          <WhatsAppButton message={waMessages.general()} context="404">Contact Us on WhatsApp</WhatsAppButton>
        </div>
      </div>
    </PublicLayout>
  );
}
